import { IconPaperclip } from '@tabler/icons-react';
import React from 'react';

/** The label/value grid of an offer's detail; the agreement section reuses it so both read as one card. */
export const OfferDetailGrid = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className='grid grid-cols-1 gap-5 p-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
    {children}
  </div>
);

export const OfferDetailField = ({
  label,
  children,
}: {
  label: React.ReactNode;
  children: React.ReactNode;
}) => (
  <div className='flex min-w-0 flex-col gap-1'>
    <p className='text-sm font-semibold uppercase tracking-wide text-dark'>
      {label}
    </p>
    {children}
  </div>
);

export const OfferDetailValue = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title?: string;
}) => (
  <p className='text-sm text-stone-900' title={title}>
    {children}
  </p>
);

export const OfferFileLink = ({
  href,
  name,
}: {
  href: string | undefined;
  name: React.ReactNode;
}) => (
  <a
    href={href}
    className='group flex items-center gap-1 truncate hover:underline'
    target='_blank'
  >
    <IconPaperclip className='w-3.5 h-3.5 shrink-0' />
    <p className='tabular-nums text-stone-900 truncate text-ellipsis text-sm'>
      {name}
    </p>
  </a>
);
